import styled from "styled-components";
import { useRecoilState } from "recoil";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faVolumeMute,
  faVolumeUp,
  faPause,
  faPlay,
  faFastForward,
  faRandom,
  faStar,
  faExpand,
  faCompress,
  faMusic,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { Button } from "../App.styles";
import {
  featuredState,
  playingState,
  shuffleState,
  useShuffleSlideshowMutation,
} from "./Slideshow.state";
import { useState } from "react";
import { useParams } from "react-router-dom";

const SlideshowControlWrapper = styled.div`
  position: absolute;
  z-index: 10000;

  button {
    margin: 0 0.5rem;
  }

  @media (max-width: ${({ theme }) => theme.maxMobileWidth}) {
    display: flex;
    ${({ top }) => top && `top: 0;`};
    ${({ right }) => right && `right: 0;`};
    ${({ bottom }) => bottom && `bottom: 0;`};
    ${({ left }) => left && `left: 0;`};

    ${({ left }) => left && `width: 66.6%;`};
    ${({ right }) =>
      right &&
      `
      justify-content: flex-end;
      width: 33.3%;
    `};

    button {
      border-radius: 0;
      box-shadow: none;
      flex-grow: 1;
      height: 3.5rem;
      margin: 0;

      &:active,
      &:focus,
      &:hover {
        box-shadow: none;
      }
    }
  }

  @media (min-width: ${({ theme }) => theme.minDesktopWidth}) {
    ${({ top }) => top && `top: ${top};`};
    ${({ right }) => right && `right: ${right};`};
    ${({ bottom }) => bottom && `bottom: ${bottom};`};
    ${({ left }) => left && `left: ${left};`};
  }
`;

const IconCompound = styled.span`
  position: relative;

  .custom-muted {
    width: 5px;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translate3d(7px, -50%, 0);
  }
`

const SlideshowControls = (props) => {
  const { muted, onSkip, onMute, onUnmute, featuredSubmissions, bgMuted, onBgMute, onBgUnmute } = props
  const [featured, setFeatured] = useRecoilState(featuredState);
  const [playing, setPlaying] = useRecoilState(playingState);
  const { game_id } = useParams();
  const { mutate: shuffleSlideshow } = useShuffleSlideshowMutation(game_id);
  const [shuffle, setShuffle] = useRecoilState(shuffleState);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      document.body.requestFullscreen();
      setIsFullscreen(true);
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
        setIsFullscreen(false);
      }
    }
  } 

  return (
    <>
      <SlideshowControlWrapper bottom="1.5rem" left="1.5rem">
        {shuffle ? (
          <Button
            color="accent1"
            title="Turn off shuffle"
            onClick={() => {
              shuffleSlideshow(false);
              setShuffle(false);
            }}
          >
            <FontAwesomeIcon icon={faRandom} />
          </Button>
        ) : (
          <Button
            color="light"
            title="Turn on shuffle"
            onClick={() => {
              shuffleSlideshow(true);
              setShuffle(true);
            }}
          >
            <FontAwesomeIcon icon={faRandom} />
          </Button>
        )}
        {muted ? (
          <Button
            color="accent1"
            title="Unmute"
            onClick={() => onUnmute()}
          >
            <FontAwesomeIcon icon={faVolumeMute} />
          </Button>
        ) : (
          <Button color="info" title="Mute" onClick={() => onMute()}>
            <FontAwesomeIcon icon={faVolumeUp} />
          </Button>
        )}
        {bgMuted ? (
          <Button
            color="accent1"
            title="Unmute Background"
            onClick={() => onBgUnmute()}
          >
            <IconCompound>
              <FontAwesomeIcon icon={faMusic} />
              <FontAwesomeIcon icon={faTimes} className="custom-muted" />
            </IconCompound>
          </Button>
        ) : (
          <Button color="info" title="Mute Background" onClick={() => onBgMute()}>
            <FontAwesomeIcon icon={faMusic} />
          </Button>
        )}
        {
          featuredSubmissions > 0
            ? featured ? (
                <Button
                  color="accent1"
                  title="Show all submissions"
                  onClick={() => setFeatured(false)}
                >
                  <FontAwesomeIcon icon={faStar} />
                </Button>
              ) : (
                <Button
                  color="dark"
                  title="Show featured submissions only"
                  onClick={() => setFeatured(true)}
                >
                  <FontAwesomeIcon icon={faStar} />
                </Button>
              )
            : null
        }
        <Button
          color="info"
          title={isFullscreen ? 'Exit Fullscreen' : 'Fullscreen'}
          onClick={toggleFullScreen}
        >
          <FontAwesomeIcon icon={isFullscreen ? faCompress : faExpand} />
        </Button>
      </SlideshowControlWrapper>
      <SlideshowControlWrapper bottom="1.5rem" right="1.5rem">
        {playing ? (
          <Button
            color="accent1"
            title="Pause"
            onClick={() => setPlaying(false)}
          >
            <FontAwesomeIcon icon={faPause} />
          </Button>
        ) : (
          <Button color="success" title="Play" onClick={() => setPlaying(true)}>
            <FontAwesomeIcon icon={faPlay} />
          </Button>
        )}
        <Button color="info" title="Next submission" onClick={onSkip}>
          <FontAwesomeIcon icon={faFastForward} />
        </Button>
      </SlideshowControlWrapper>
    </>
  );
};

export default SlideshowControls;
